<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="选择等级" prop="endDate">
            <el-select v-model="queryParams.type" placeholder="请选择">
              <el-option
                v-for="item in levelData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>每日体力盈亏统计 (盈亏:当日发放-当日消耗)</span>
        </div>

        <el-table
          :data="tableData"
          border
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
            width="130"
          />
          <el-table-column
            v-for="(item, index) in rangeTitle"
            :ke="index"
            :label="item"
            align="center"
          >
            <el-table-column
              label="人数"
              align="center"
            >
              <template scope="scope">
                {{ data[scope.row.date][index].user }}
              </template>
            </el-table-column>
            <el-table-column
              label="人均"
              align="center"
            >
              <template scope="scope">
                {{ data[scope.row.date][index].avg }}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-card>

      <el-row :gutter="12">
        <userStat ref="userStat" />
      </el-row>

      <el-row :gutter="12">
        <userStat ref="userStatRate" :rate="true" :title="'人数占比'" />
      </el-row>

      <el-row :gutter="12">
        <userStat ref="userAvgStat" :title="'人均'" :k="'avg'" />
      </el-row>

    </template>
  </BasicLayout>
</template>

<script>
import { getSpinProfitLossStat } from '@/api/user/user_info'
import userStat from '@/views/config/spin-stat-profit-loss/components/user-stat.vue'
import { getCacheQuery, getLastDates, scientificFormat, setCacheQuery } from '@/utils'
export default {
  name: 'CurrencySources',
  components: {
    userStat
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        type: 0
      },
      rangeTitle: [],
      levelData: {},
      tableData: [],
      data: {}
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }

    this.getTables(undefined)
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables(event) {
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getSpinProfitLossStat(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          const level = res.data.level
          this.levelData = [{ label: '全部', value: 0 }]
          for (let i = 1; i <= level; i++) {
            this.levelData.push({ label: '等级' + i, value: i })
          }
          const rangeArr = res.data.rangeArr
          const rangeTitle = []
          for (const i in rangeArr) {
            const val = rangeArr[i]
            rangeTitle.push(val[0] + ' ~ ' + val[1])
          }
          this.data = {}
          for (const i in res.data.data) {
            const val = res.data.data[i]
            this.data[val.date] = []
            for (const k in val.data) {
              const val2 = val.data[k]
              this.data[val.date].push(val2)
            }
          }
          this.$refs.userStat.refresh(res.data.data, rangeTitle)
          this.$refs.userStatRate.refresh(res.data.data, rangeTitle)
          this.$refs.userAvgStat.refresh(res.data.data, rangeTitle)
          this.rangeTitle = rangeTitle
          this.tableData = res.data.data
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
